import { HelpCircle } from 'lucide-react';
import type { ChoicePrompt } from '@/protocol/media';
import { useSession } from '@/session/store';

/** A question the agent needs answered before it can search. Answering it sends the option's label. */
export function ChoiceBlock({ choice }: { choice: ChoicePrompt }) {
  const send = useSession((state) => state.send);
  // Offline only. The question routinely arrives while the reply that asks it is still being spoken,
  // and waiting out the rest of it to answer is exactly what nobody does in front of a television.
  const busy = useSession((state) => state.connection !== 'open');

  return (
    <section className="border-line bg-surface/70 rounded-panel flex flex-col gap-3 border p-4">
      <h3 className="flex items-start gap-2 text-sm font-semibold tracking-tight">
        <HelpCircle className="text-accent-soft mt-0.5 size-4 shrink-0" />
        {choice.prompt}
      </h3>
      <div className="flex flex-wrap gap-2">
        {choice.options.map((option, index) => (
          <button
            key={option.optionId ?? `${option.label}-${index}`}
            type="button"
            disabled={busy}
            onClick={() => send(option.label)}
            className="border-line bg-raised hover:border-accent/60 hover:bg-hover rounded-xl border px-4 py-2 text-sm font-medium transition disabled:pointer-events-none disabled:opacity-40"
          >
            {option.label}
          </button>
        ))}
      </div>
    </section>
  );
}
